import { Views } from "features/enumerations";
import { ResolvePath } from "features/firebase-app";
import useAuth from "hooks/useAuth";
import { useEffect } from "react"
import { useNavigate } from "react-router-dom";

export default function AnonymousSignin(props: any) {
    const { isLoggedIn } = useAuth();
    const { firebaseAnonymousSignIn, firebaseGoogleSignIn } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (isLoggedIn) {
            navigate(ResolvePath(`/${Views.Home}`), { replace: true });

        }
        else {
            anonymousHandler();
        }
    }, [isLoggedIn])
    const anonymousHandler = async () => {
        try {
            await firebaseAnonymousSignIn();
        } catch (err) {
            console.error(err);
        }
    };
    return (
        <>
            <div></div>
        </>
    )
}